import React, { useContext } from 'react'
import cn from 'classnames'

import { FeatureHighlight } from '../item/feature-highlight'
import { FeatureHighlightProvider } from '../../contexts/feature-highlight-context'
import { SectionContext } from '../../contexts/section-context'
import { SingleColumnLayout } from '../layout/single-column'
import { containedImageStyle } from '../ui-lib/image'
import { FixedSpacer } from '../ui-lib/spacer'
import { getSectionAnchorId, PageSectionProps } from './index'
import { useBackgroundStyle } from './theme'
import { SectionThemeContext } from '../../contexts/section-theme-context'
import { PageSwoosh } from '../../lib/types'
import { getSwooshStyle } from '../swoosh'

import styles from './group.module.scss'
import bts25SwooshStyles from '../swoosh/bts-25-swoosh.module.scss'

export const GroupPageSection: React.FC<
  PageSectionProps & { sectionGroupSwoosh?: PageSwoosh; backgroundType?: string }
> = ({ className, children, background, heading, sysStructure, sectionGroupSwoosh, backgroundType }) => {
  const anchorId = getSectionAnchorId(sysStructure)
  const { isH1Section, isReducedHeroPadding } = useContext(SectionContext)
  const theme = useContext(SectionThemeContext)
  const backgroundStyle = useBackgroundStyle(theme, background?.color)

  const { className: swooshClassName, backgroundImage } = getSwooshStyle(sectionGroupSwoosh)

  return (
    <div
      id={anchorId}
      className={cn(
        containedImageStyle,
        ...backgroundStyle,
        className,
        backgroundType === 'keychainGradient' && bts25SwooshStyles.gradientKeychainBackground,
        backgroundType === 'gridBackground' && bts25SwooshStyles.gridBackground,
        backgroundType === 'cloudBackground' && bts25SwooshStyles.cloudBackground,
        backgroundType === 'cloudToWhiteBackground' && bts25SwooshStyles.cloudToWhiteBackground,
        backgroundType === 'gradientGridBackground' && bts25SwooshStyles.gradientGridBackground
      )}
    >
      <div
        className={cn(swooshClassName, styles.container, isReducedHeroPadding && styles.reducedHero)}
        style={{ backgroundImage }}
      >
        {heading && (
          <FeatureHighlightProvider value={{ titleStyle: 'T1' }}>
            <SingleColumnLayout>
              <FeatureHighlight structure={heading} titleTag={isH1Section ? 'h1' : 'h2'} />
              <FixedSpacer multiplier={2} />
            </SingleColumnLayout>
          </FeatureHighlightProvider>
        )}
        {children}
      </div>
    </div>
  )
}
